import Headers from '@/component/Headers';
import Buttons from '@/component/popups/Buttons';
import PopupFrame from '@/component/popups/ui-1';
import DontLoseYourStreak from '@/component/popups/ui-1/DontLoseYourStreak';
import OutOfTurns from '@/component/popups/ui-1/OutOfTurns';
import StreakRestored from '@/component/popups/ui-4/StreakRestored';
import RuleContent from '@/component/RuleContent';
import PATH from '@/config/PATH';
import {
  getStreakStatus,
  postLoginStreakReset,
  postLoginStreakRevive
} from '@/Redux/futures/shweJourney/actions';
import { curLoginStreakStatus } from '@/Redux/selector';
import { formatDataNumberToen } from '@/utils/helper';
import ReviveImg from '@assets/web-v3-images/btn-Revive.png';
import btnImgLock from '@assets/web-v3-images/btnImgLock.png';
import fireImg from '@assets/web-v3-images/fire.png';
import frameImg from '@assets/web-v3-images/Frame.png';
import FramIconImg from '@assets/web-v3-images/Frame34109.png';
import FrameActiveImg from '@assets/web-v3-images/FrameActive.png';
import frameQuickRuleImg from '@assets/web-v3-images/FrameQuickRule.png';
import FrameShweJourneyMasterImg1 from '@assets/web-v3-images/FrameShweJourney-master1.png';
import FrameShweJourneyMasterImg2 from '@assets/web-v3-images/FrameShweJourney-master2.png';
import FrameShweJourneyImg1 from '@assets/web-v3-images/FrameShweJourney1.png';
import FrameShweJourneyImg2 from '@assets/web-v3-images/FrameShweJourney2.png';
import FrameUnActiveImg from '@assets/web-v3-images/FrameUnActive.png';
import hammerIconImg from '@assets/web-v3-images/hammer-icon.png';
import hammerImg from '@assets/web-v3-images/hammer.png';
import imgConfirm from '@assets/web-v3-images/icon-confirm.png';
import lightningImg from '@assets/web-v3-images/image.png';
import { Text } from '@radix-ui/themes';
import { useEffect, useRef, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import EventDays from './components/EventDays/EventDays';

const Items = ({ setChecked, checked, images, text, type, disabled }) => {
  const handleClick = () => {
    if (disabled) return;
    setChecked(type);
  };

  return (
    <div
      className={`relative w-full ${disabled ? "opacity-40 cursor-not-allowed pointer-events-none" : ""}`}
      onClick={handleClick}
    >
      <img src={checked === type ? FrameActiveImg : FrameUnActiveImg} className="w-full" />

      <div className="absolute inset-0 flex items-center justify-center gap-2 px-0 sm:px-2 md:px-2 lg:px-6 xl:px-6">
        <img src={images} className="w-6 sm:w-10 md:w-18 lg:w-20 xl:w-20" />
        <span
          className={`text-[13px] sm:text-[17px] md:text-[24px] font-bold ${checked === type ? 'text-[#E04F16]' : 'text-[#772917]'
            }`}
        >
          {text || ''}
        </span>
      </div>
    </div>
  );
};

const ReviveStreak = ({
  data,
  checked,
  setChecked,
  setDataClaim,
  setOpenPurchaseSuccess,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const [openRevive, setOpenRevive] = useState(false);
  const [openOutOfTurns, setOpenOutOfTurnsRevive] = useState(false);
  const [openReset, setOpenReset] = useState(false);
  const isRevivingRef = useRef(false);

  const userTurnBalance = data?.revive?.user_turn_balance || 0;
  const userReviveItemBalance = data?.revive?.user_revive_item_balance || 0;
  const userCostTurn = data?.revive?.cost_turn || 0;
  const userCostReviveItem = data?.revive?.cost_revive_item || 0;

  const afterRevive = (data, isLoading, dataError) => {
    if (isLoading) return;
    isRevivingRef.current = false;

    if (dataError) {
      toast.error(dataError?.errorMessage);
      return;
    }

    if (data) {
      setDataClaim(data?.data);
      setOpenRevive(false);
      setOpenPurchaseSuccess(true);
      setOpenOutOfTurnsRevive(false);
      dispatch(getStreakStatus({}));
    }
  };

  const handleRevive = async () => {
    if (isRevivingRef.current) return;
    if (checked === 'TURN' && userTurnBalance < userCostTurn) {
      setOpenOutOfTurnsRevive(true);
      return;
    }
    if (checked === 'REVIVE_ITEM' && userReviveItemBalance < userCostReviveItem) {
      setOpenOutOfTurnsRevive(true);
      return;
    }
    isRevivingRef.current = true;
    const body = {
      payment_method: checked,
      callback: afterRevive,
    };
    await dispatch(postLoginStreakRevive(body));
  };

  const afterReset = (data, isLoading, dataError) => {
    if (isLoading) return;

    if (dataError) {
      toast.error(dataError?.errorMessage);
      return;
    }

    if (data) {
      dispatch(getStreakStatus({}));
    }
  };

  const handleReset = async () => {
    setOpenReset(true)
  }

  const handleSubmitReset = async () => {
    const body = {
      callback: afterReset,
    };
    await dispatch(postLoginStreakReset(body));
  }

  const handleOpenRevive = () => {
    if (data?.day_off === 0) {
      setOpenOutOfTurnsRevive(true)
    } else {
      setOpenRevive(true);
    }
  };
  return (
    <>
      <div
        className="relative w-full mt-4 px-4 pt-9 sm:pt-16 pb-4 sm:pb-8"
        style={{
          backgroundImage: `url(${frameImg})`,
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center',
        }}
      >
        <Text
          className="
					absolute left-1/2 top-1.5 sm:top-3 -translate-x-1/2
					text-[17px] sm:text-[30px]
					font-bold text-[#7A2E0E]
				"
        >
          {t("shwe_journey.revive_streak")}
        </Text>

        <div className="mt-3 sm:mt-7 mx-2 sm:mx-4 ">
          <Text
            as="p"
            className="text-xl sm:text-xl md:text-3xl lg:text-4xl xl:text-4xl text-[rgba(217,45,32,1)] font-bold pb-2"
          >
            {t("shwe_journey.day_off")}: {data?.day_off || 0}
          </Text>

          <Text
            as="p"
            className="text-base/[30px] sm:text-2xl/[30px] text-[#713B12] pt-0"
          >
            <Trans
              i18nKey="shwe_journey.revive_with"
              components={{
                bold1: <Text className="font-bold" />,
                bold2: <Text className="font-bold" />,
              }}
            />
          </Text>

          <div className="flex gap-4 justify-between mt-2 sm:mt-6">
            <Items
              setChecked={setChecked}
              images={hammerImg}
              text={t("shwe_journey.3_turns").replace("_LP_", userCostTurn || 0)}
              checked={checked}
              type="TURN"
            // disabled={userTurnBalance === 0}
            />

            <Items
              setChecked={setChecked}
              images={lightningImg}
              text={t("shwe_journey.1_revive_item").replace("_LP_", userCostReviveItem || 0)}
              checked={checked}
              type="REVIVE_ITEM"
              disabled={userReviveItemBalance === 0}
            />
          </div>

          <div className="mt-4 sm:mt-8">
            <button
              onClick={handleOpenRevive}
              className={`
							relative w-full cursor-pointer btn-click-active 
							`}
            >
              <img src={ReviveImg} className="block w-full h-auto" alt="Revive" />
              <Text
                className="absolute inset-0 -top-1 flex items-center justify-center text-[14px] sm:text-3xl font-semibold text-white"
                style={{
                  WebkitTextStroke: '4px #D86B00',
                  paintOrder: 'stroke fill',
                }}
              >
                {t("shwe_journey.revive")}
              </Text>
            </button>
          </div>
          <p onClick={handleReset} className="text-[rgba(224,79,22,1)] text-sm font-semibold italic underline text-center text-[14px] sm:text-[23px] cursor-pointer">
            {t("shwe_journey.start_a_new_streak_instead")}
          </p>
        </div>
      </div>
      <DontLoseYourStreak
        onOpenChange={setOpenRevive}
        open={openRevive}
        checked={checked}
        days={data?.day_off}
        cost_revive_item={data?.revive?.cost_revive_item}
        cost_turn={data?.revive?.cost_turn}
        disabled={data?.revive?.cost_turn}
        userReviveItemBalance={userReviveItemBalance}
        userTurnBalance={userTurnBalance}
        setChecked={setChecked}
        handleClick={handleRevive}
      />
      <PopupFrame
        open={openReset} onOpenChange={setOpenReset} title={t('confirmation')} classNames=''
      >
        <div className='px-[11%] sm:px-[15%]'>
          <img src={imgConfirm} alt="" className='px-[10%]' />
          <p className='text-[rgba(161,92,7,1)] text-[14px] sm:text-[20px] font-medium text-center'>
            {t('shwe_journey.you_will_permanently_lose_your_N_day_streak').replace("_LP_", formatDataNumberToen(data?.current_streak))}
          </p>
          <Buttons handleClick={handleSubmitReset} textBtn={t('modal.modal_login.confirm')} classItem='!mb-0' classItemText='' />
        </div>
      </PopupFrame>
      <OutOfTurns open={openOutOfTurns} onOpenChange={setOpenOutOfTurnsRevive} hiddenText={false} />
    </>
  );
};

const QuickRule = ({ data }) => {
  const { t, i18n } = useTranslation()
  return (
    <div
      className="relative w-full aspect-[1080/450] mb-5 mt-4"
      style={{
        backgroundImage: `url(${frameQuickRuleImg})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top center',
        backgroundSize: '100% 100%',
      }}
    >
      <Text className={`absolute left-1/2 top-[13%] -translate-x-1/2 -translate-y-1/2 ${i18n.language === 'my' ? 'text-[13px] sm:text-[24px]' : 'text-[15px] sm:text-[25px]'} font-bold text-[#7A2E0E]`}>
        {t("shwe_journey.quick_rule")}
      </Text>
      <div
        className="
					absolute
					left-[5%]
					right-[18%]
					top-[60%]
					-translate-y-1/2
					h-[70%]
					flex
					items-center
  			"
      >
        <div
          className="w-[75%] max-h-full overflow-y-auto pr-2 hide-scrollbar scrollbar-h-2
										scrollbar-thin
										scrollbar-thumb-[#E6B97D]
										scrollbar-track-transparent"
        >
          <RuleContent
            content={data?.quick_rule || ''}
            className="text-left text-[#542314] text-[13px] md:text-[23px] font-medium"
          />
        </div>
      </div>
    </div>
  );
};

const Numberkeys = ({ count, type = 1, hidden = false, handleClick }) => {
  return (
    <div
      className="
				absolute
				top-[18%] left-[5%]
				sm:top-[18%] sm:left-[5%]
				md:top-[20%] md:left-[5%]
			"
    >
      <div
        className={`
					relative
					${hidden ? 'w-20' : 'w-24'}
					h-8
					sm:${hidden ? 'w-20' : 'w-24'} sm:h-8
					md:${hidden ? 'w-24' : 'w-28'} md:h-9
					lg:${hidden ? 'w-29' : 'w-30'} lg:h-10
					p-2 lg:p-5
					rounded-2xl lg:rounded-3xl
					border-[3px] border-transparent
  `}
        style={{
          background: `
						linear-gradient(
							180deg,
							rgba(253,220,174,1),
							rgba(255,255,255,1),
							rgba(255,231,205,1)
						) padding-box,
						linear-gradient(
							180deg,
							rgba(255,184,108,1),
							rgba(255,232,208,1),
							rgba(255,216,161,1)
						) border-box
					`,
        }}
      >
        <img
          src={type === 1 ? hammerIconImg : FramIconImg}
          alt=""
          className="
						absolute
						-top-[4px] -left-3
						md:-top-3 md:-left-4
						lg:-top-2 lg:-left-4
						w-8 h-8
						md:w-11 md:h-11
						lg:w-13 lg:h-13
					"
        />

        <span
          className={` 
						absolute inset-0
						flex items-center justify-center
						font-bold text-[#55160C]
						text-sm
						md:text-base
						lg:text-lg
						${hidden ? 'pl-6 md:pl-8 lg:pl-8' : ''}
				`}
        >
          {count}
        </span>
        {!hidden && (
          <img
            src={btnImgLock}
            alt=""
            onClick={handleClick}
            className="
							btn-click-active
							absolute
							right-1
							top-1/2
							-translate-y-1/2
							w-6 h-6
							md:w-7 md:h-7
							lg:w-8 lg:h-8
							"
          />
        )}
      </div>
    </div>
  );
};

export default function ShweJourney() {
  const { t } = useTranslation()
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loginStreakStatus } = useSelector(curLoginStreakStatus);
  const [openPurchaseSuccess, setOpenPurchaseSuccess] = useState(false);
  const [dataClaim, setDataClaim] = useState('');
  const [checked, setChecked] = useState('TURN');

  const handleCount = () => {
    navigate(PATH.PACKAGE);
  };

  useEffect(() => {
    dispatch(getStreakStatus({}));
  }, [dispatch]);

  useEffect(() => {
    if (loginStreakStatus?.user_turn_balance != null) {
      setCount(loginStreakStatus.user_turn_balance);
    }
  }, [loginStreakStatus]);

  return (
    <div className="flex flex-col min-h-screen">
      <div
        className="relative aspect-[1072/959] "
        style={{
          backgroundImage: `url(${loginStreakStatus?.rank === 'MASTER' ? FrameShweJourneyMasterImg1 : FrameShweJourneyImg1})`,
          backgroundSize: '100% auto',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center',
        }}
      >
        <div className="absolute top-[25%] left-[5%]">
          <Numberkeys count={count} handleClick={handleCount} type={1} />
        </div>
        <div className="absolute top-[25%] left-[125px] sm:left-[23%]">
          <Numberkeys count={loginStreakStatus?.user_revive_item_balance || 0} type={2} hidden />
        </div>
        <div className="pt-4 sm:pt-12">
          <Headers
            // trailIcon={<ShareIcon className="size-full object-contain" />}
            title={t("shwe_journey.shwe_journey")}
            iconSizeCustom='!w-8 sm:!w-16'
          />
        </div>
        <div className="absolute left-1/2 top-[63%] sm:top-[59%] -translate-x-1/2 -translate-y-1/2 inline-flex flex-col items-center w-full">
          <div className="relative inline-block">
            <img src={fireImg} className="block w-26 sm:w-45 h-auto" alt="fire" />
            <Text
              className="
								absolute
								inset-0
								flex
								items-center
								justify-center
								text-[#FEFDF0]
								text-2xl
								sm:text-6xl
								font-black
								pt-[42%]
							"
              style={{
                WebkitTextStroke: '1px #DE1900',
              }}
            >
              {loginStreakStatus?.current_streak || 0}
            </Text>
          </div>

          <Text
            as="p"
            className="
						mt-2
						text-center
						text-2xl
						sm:text-3xl
						md:text-4xl
						lg:text-6xl
						font-extrabold
						text-[#932F19]
					"
          >
            {t("shwe_journey.days_streak")}
          </Text>
        </div>
      </div>
      <div
        className="flex-1 px-4 pt-10 -mt-[2px]"
        style={{
          backgroundImage: `url(${loginStreakStatus?.rank === 'MASTER' ? FrameShweJourneyMasterImg2 : FrameShweJourneyImg2})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center',
          backgroundSize: '100% 100%',
        }}
      >
        <EventDays data={loginStreakStatus} />
        {
          loginStreakStatus?.day_off !== 0 && (
            <ReviveStreak
              data={loginStreakStatus}
              checked={checked}
              setChecked={setChecked}
              setDataClaim={setDataClaim}
              setOpenPurchaseSuccess={setOpenPurchaseSuccess}
            />
          )
        }
        <QuickRule data={loginStreakStatus} />
      </div>

      <StreakRestored
        open={openPurchaseSuccess}
        onOpenChange={setOpenPurchaseSuccess}
        data={loginStreakStatus}
        dataClaim={dataClaim}
        checked={checked}
        handleClick={() => {
          setOpenPurchaseSuccess(false);
        }}
        textBtn={t('shwe_journey.claim_todays_reward')}
      />
    </div>
  );
}